import { render } from "./Invigilators.vue?vue&type=template&id=7f56dd20"
import script from "./Invigilators.vue?vue&type=script&lang=js"
export * from "./Invigilators.vue?vue&type=script&lang=js"
script.render = render

export default script